module.exports = {
  "generateFormats": [
    "webp"
  ],
  "convertFormat": [
    [
      "jpg",
      "webp"
    ],
    [
      "jpeg",
      "webp"
    ],
    [
      "png",
      "webp"
    ]
  ]
}